import { render } from "./ProposalStatus.vue?vue&type=template&id=2d782bc2&scoped=true&ts=true"
import script from "./ProposalStatus.vue?vue&type=script&lang=ts"
export * from "./ProposalStatus.vue?vue&type=script&lang=ts"

import "./ProposalStatus.vue?vue&type=style&index=0&id=2d782bc2&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d782bc2"]])

export default __exports__